import React, {PropTypes} from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin';

import './FlagControl.scss';

class FlagControl extends React.Component {

    static propTypes = {
        iso: PropTypes.string.isRequired,
        ext: PropTypes.string,
    }

    static defaultProps = {
        ext: 'png',
    }

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        let image = '';
        if (this.props.iso) {
          image = `${this.props.iso}.${this.props.ext}`;
        } else {
          image = 'WO.png';
        }

        try {
            var src = `data:image/${this.props.ext};base64,` +
                require(`!base64!./png/16/${image}`);
        } catch (e) {
            var src = `data:image/${this.props.ext};base64,` +
                require(`!base64!./png/16/WO.png`);
        }

        return (
            <img className='FlagControl-image' src={src}/>
        );
    }
}

export default FlagControl;



// WEBPACK FOOTER //
// ./client/components/FlagControl/FlagControl.js